import React, { useEffect, useRef, useState } from "react";
import "../css/Grid.css";


const types = ["INSTAGRAM", "TIKTOK"];

const labels = {
  INSTAGRAM: "Instagram",
  TIKTOK: "TikTok"
};

// Matches --color-surface-bg, the page background when the user hasn't picked a color.
const DEFAULT_BACKGROUND_COLOR = "#ffffff";
const STUCK_TINT_OPACITY = 0.7;

/** "#1a2b3c" -> "rgba(26, 43, 60, 0.7)". The input is already validated as #rrggbb by userLoader. */
function translucent(hexColor, opacity) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

/**
 * With a custom background, the bar is transparent so the background shows through, and
 * turns frosted once it sticks to the top, so the labels stay readable over scrolling posts.
 * Without one, it keeps the default solid bar.
 */
function TabGroup({ onTabChange, activeTab, hasCustomBackground = false, backgroundColor }) {
  const sentinelRef = useRef(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    if (!hasCustomBackground || !sentinelRef.current) return undefined;
    // The sentinel sits just above the bar; once it scrolls off the top, the bar is stuck.
    const observer = new IntersectionObserver(([entry]) => {
      setIsStuck(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasCustomBackground]);

  const className = [
    "profile-grid-tabs",
    hasCustomBackground && "has-custom-background",
    hasCustomBackground && isStuck && "is-stuck",
  ].filter(Boolean).join(" ");

  const style = hasCustomBackground
    ? { "--tabs-stuck-bg": translucent(backgroundColor || DEFAULT_BACKGROUND_COLOR, STUCK_TINT_OPACITY) }
    : undefined;

  return (
    <>
      {hasCustomBackground && <div ref={sentinelRef} className="profile-grid-tabs-sentinel" aria-hidden="true" />}
      <div className={className} style={style}>
        {types.map((type) => (
          <button
            key={type}
            className={`tab ${activeTab === type ? "is-active" : ""}`}
            onClick={() => onTabChange(type)}
          >
            {labels[type]}
          </button>
        ))}
      </div>
    </>
  );
}

export default TabGroup;
